import { sortByRenderedLabel } from "./sort-by-rendered-label";

type OptionWithLabel = {
  label: string;
};

export function sortOptionsByLabel<T extends OptionWithLabel>(options: readonly T[]): T[] {
  return sortByRenderedLabel(options, (option) => option.label);
}
